import { Image, StyleSheet, View, useWindowDimensions } from "react-native";
import React, { useRef, useState } from "react";
import { SCREEN_WIDTH, fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { getUserDetails, newsLetterSubscribe } from "appRedux/reducers/profileSlice";
import { useDispatch, useSelector } from "react-redux";

import Buttons from "components/Buttons";
import Carousel from "react-native-reanimated-carousel";
import { Images } from "assets";
import Input from "components/Input";
import Pagination from "src/components/Pagination";
import { REGEX } from "utils/Constants";
import { Svg } from "assets/svg";
import VText from "components/VText";
import { useGlobalSearchParams } from "expo-router";

const ComingSoonCop = ({ type = "CONCIERGE" }) => {
    const dispatch = useDispatch();
    const _slider1Ref = useRef();
    const [email, setEmail] = useState("");
    const [isEmailError, setIsEmailError] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [isSuccessModal, setIsSuccessModal] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const userId = useSelector((state) => state.AuthReducer.userId);
    const [activeIndex, setActiveIndex] = useState(0);

    const gender = useGlobalSearchParams()?.gender ?? "female";

    const handleSubmit = () => {
        let trimmedEmail = email?.trim();

        if (REGEX.email.test(trimmedEmail)) {
            setIsLoading(true);
            dispatch(
                newsLetterSubscribe({
                    emailId: trimmedEmail,
                    origin: "Coming Soon " + type.toLowerCase(),
                    gender: gender,
                })
            )
                .then((res) => {
                    if (res.payload.data.data.statusCode === 200) {
                        setIsSuccessModal(true);

                        setTimeout(() => {
                            setIsSuccessModal(false);
                        }, 4000);

                        if (userId) {
                            dispatch(getUserDetails(userId));
                        }

                        setEmail("");
                    } else {
                        setErrorText("You are already subscribed to our newsletter with this email.");
                    }
                    setIsLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            setIsEmailError(true);
            setErrorText("Please enter valid email");
        }
        // setIsSuccessModal(true);
    };

    const checkEmailAlreadySubscribed = (email) => {
        let trimmedEmail = email?.trim();
        dispatch(newsLetterSubscribe({ emailId: trimmedEmail, justCheck: true })).then((res) => {
            if (res.payload.data.data.statusCode != 200) {
                setIsEmailError(true);
                setErrorText("You are already subscribed to our newsletter with this email.");
            }
        });
    };

    const handleInputChange = (txt) => {
        let trimmedTxt = txt?.trim();

        if (REGEX.email.test(trimmedTxt) || trimmedTxt?.length === 0) {
            checkEmailAlreadySubscribed(trimmedTxt);
            setIsEmailError(false);
            setErrorText("");
        } else {
            setIsEmailError(true);
            setErrorText("Please enter valid email");
        }
        setEmail(trimmedTxt);
    };

    let data = [];
    let heading = "";
    switch (type) {
        case "CONCIERGE":
            heading = "COMING SOON: CONCIERGE SERVICES";
            data = [
                { image: Images.AppSliderImage3 },
                { image: Images.AppSliderImage4 },
                { image: Images.AppSliderImage5 },
            ];
            break;
        case "MEN":
            heading = "COMING SOON: MEN’S COLLECTION";
            data = [
                { image: Images.MensSliderImage1 },
                { image: Images.MensSliderImage2 },
                { image: Images.MensSliderImage3 },
            ];
            break;
        case "STYLIST":
            heading = "COMING SOON: VÊTIR AI STYLIST";
            data = [
                { image: Images.StylistSliderImage1 },
                { image: Images.StylistSliderImage2 },
                { image: Images.StylistSliderImage3 },
            ];
            break;
        case "VIDEOS":
            heading = "COMING SOON: SHOPPABLE VIDEOS";
            data = [
                { image: Images.VideoSliderImage1 },
                { image: Images.VideoSliderImage2 },
                { image: Images.VideoSliderImage3 },
            ];
    }

    const _renderItem = ({ item, index }) => {
        const isActive = activeIndex === index;
        return (
            <Image
                source={item.image}
                accessibilityLabel={`Coming Soon Image ${index + 1}`}
                style={{ width: "400", height: "100%", opacity: isActive ? 1 : 0.5 }}
                resizeMode="contain"
            ></Image>

            // </View>
        );
    };

    return (
        <View
            style={{
                paddingTop: spV(10),
                backgroundColor: "#000000",
            }}
        >
            <View style={styles.container}>
                <View
                    style={{
                        backgroundColor: "#000000",
                        width: "50%",
                        color: "white",
                        margin: "auto",
                        paddingRight: spH(50),
                    }}
                >
                    <VText style={{ fontSize: fp(32), fontWeight: "400", fontFamily: "LibreBodoni", color: "white" }}>
                        {heading}
                    </VText>
                    <VText
                        style={{
                            fontSize: fp(16),
                            fontWeight: "300",
                            fontFamily: "JosefinSans",
                            color: "white",
                            lineHeight: 28,
                            marginTop: spV(10),
                        }}
                    >
                        Sign up below for updates and first access. 
                    </VText>

                    <View
                        style={{
                            marginTop: spV(20),
                            alignItems: "center",
                            flexDirection: "row",
                        }}
                    >
                        <Input
                            leftIcon={() => (
                                <View style={{ height: 27, marginRight: 10 }}>
                                    <svg
                                        width="24"
                                        height="25"
                                        viewBox="0 0 24 25"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M11.9991 11.6075L21.5841 5.45C21.1987 5.16096 20.7308 5.00323 20.2491 5H3.74906C3.26736 5.00323 2.79942 5.16096 2.41406 5.45L11.9991 11.6075Z"
                                            fill={isEmailError ? "#CE1A1A" : "#212427"}
                                            fillOpacity={email?.length > 0 ? "1" : "0.3"}
                                        />
                                        <path
                                            d="M12.405 13.1303L12.2775 13.1903H12.2175C12.1484 13.2212 12.0751 13.2414 12 13.2503V13.2503C11.9377 13.2582 11.8748 13.2582 11.8125 13.2503H11.7525L11.625 13.1903L1.575 6.69531C1.52698 6.87647 1.50179 7.06291 1.5 7.25031V17.7503C1.5 18.347 1.73705 18.9193 2.15901 19.3413C2.58097 19.7633 3.15326 20.0003 3.75 20.0003H20.25C20.8467 20.0003 21.419 19.7633 21.841 19.3413C22.2629 18.9193 22.5 18.347 22.5 17.7503V7.25031C22.4982 7.06291 22.473 6.87647 22.425 6.69531L12.405 13.1303Z"
                                            fill={isEmailError ? "#CE1A1A" : "#212427"}
                                            fillOpacity={email?.length > 0 ? "1" : "0.3"}
                                        />
                                    </svg>
                                </View>
                            )}
                            containerStyle={{ width: wp(280), color: "#000000", backgroundColor: "#fff" }}
                            showIcon
                            placeholder="Email"
                            inputContainerStyle={{
                                height: hp(40),
                                borderColor: email?.length > 0 ? (isEmailError ? "#CE1A1A" : "#000000") : "#00000029",
                            }}
                            value={email}
                            onChangeText={handleInputChange}
                            propStyle={{
                                borderRadius: 0,
                                width: "100%",
                                color: isEmailError ? "#CE1A1A" : "#212427",
                                fontSize: fp(16),
                                outlineStyle: "none",
                            }}
                        />
                        <Buttons
                            disabled={isEmailError || isLoading || email?.length === 0}
                            containerStyle={{
                                borderRadius: 0,
                                width: wp(130),
                                padding: 0,
                                marginLeft: spH(10),
                                backgroundColor:
                                    isEmailError || isLoading || email?.length === 0 ? "#FFFFFF4D" : "#FFFFFF4D",
                                height: hp(40),
                            }}
                            inputContainerStyle={{
                                height: hp(36),
                            }}
                            text="NOTIFY ME"
                            textStyle={{
                                fontSize: fp(16),
                                fontWeight: "350",
                                fontFamily: "JosefinSans",
                            }}
                            onPress={() => {
                                if (REGEX.email.test(email)) {
                                    handleSubmit();
                                } else {
                                    setIsEmailError(true);
                                    setErrorText("Please enter valid email");
                                }
                            }}
                        />
                    </View>
                </View>
                <View style={{ alignItems: "center", paddingTop: 20, backgroundColor: "#000000", width: "50%" }}>
                    <Carousel
                        loop
                        width={330}
                        height={450} // added 32 + extra for dynamic image height
                        ref={_slider1Ref}
                        autoPlay={true}
                        autoPlayInterval={2000}
                        data={data}
                        onConfigurePanGesture={(PanGesture) => {}}
                        style={{ overflow: "visible" }}
                        mode="parallax"
                        modeConfig={{
                            parallaxScrollingScale: 1,
                            parallaxScrollingOffset: 100,
                            parallaxAdjacentItemScale: 0.75,
                        }}
                        scrollAnimationDuration={1000}
                        renderItem={_renderItem}
                        onSnapToItem={(index) => setActiveIndex(index)}
                        numberOfVisibleItems={3}
                    />
                    <Pagination
                        thickness={8}
                        backgroundColor="white"
                        data={Array.isArray(data) ? data : []}
                        selectedIndex={activeIndex}
                        containerStyle={{
                            width: "100px",
                            marginTop: spV(10),
                            paddingVertical: 14,
                            alignItems: "center",
                            justifyContent: "center",
                            // backgroundColor:"red"
                        }}
                    />
                </View>
            </View>
        </View>
    );
};

const SuccessModal = () => {
    return (
        <View style={{ ...styles.successModalContainer }}>
            <View style={{ marginBottom: spV(20) }}>
                {" "}
                <Image accessibilityLabel="Done Icon" style={{ width: 48, height: 48 }} source={Svg.doneIconWhiteSvg} />{" "}
            </View>
            <VText style={styles.aboutHeadingText}>Thank You For Signing Up</VText>
            <VText style={{ ...styles.aboutSubText, fontSize: fp(16), width: wp(650) }}>
                You are now subscribed to our newsletters.
            </VText>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "#000000",
        paddingBottom: spV(50),

        paddingHorizontal: spH(120),
        flexDirection: "row",
    },
    successModalContainer: {
        flex: 1,
        alignItems: "center",
        paddingVertical: spV(200),
        paddingHorizontal: spH(60),
    },

    aboutTextContainer: {
        width: (SCREEN_WIDTH - 120) * 0.4,
    },
    aboutHeadingText: {
        fontFamily: "LibreBodoni",
        fontSize: fp(20),
        fontWeight: "300",
        color: "white",
    },
    aboutSubText: {
        textAlign: "center",
        color: "white",
        marginTop: spV(10),
        fontSize: fp(14),
        fontWeight: "350",
    },
});

export default React.memo(ComingSoonCop);
